import { memo, useEffect } from 'react'
import { useOpenedRoomId } from '$logic/opened-room'
import { useRoomAttribute } from '$logic/room/react-hook'
import { SendField } from '$comp/_app/components/chat/components/footer/components/send-field'
import { PvFooter } from './components/pv-footer'
import { WappRoomFooter } from './components/wapp-room-footer'
import { HallFooter } from './components/hall-footer'
import { SEND_FIELD_DEFAULT_HEIGHT } from '$comp/_app/components/chat/components/conf'
import { dispatchSetSendFieldHeight } from '$comp/main/root.action'

export const Footer = memo(function FooterComponent() {
  const roomId = useOpenedRoomId()
  const roomType = useRoomAttribute('type', roomId || '')
  useEffect(() => {
    dispatchSetSendFieldHeight(SEND_FIELD_DEFAULT_HEIGHT)
  }, [])

  if (!roomId) return null
  if (roomType === 'PV') return <PvFooter roomId={roomId} />

  if (roomType === 'WAPP_ROOM') return <WappRoomFooter roomId={roomId} />

  if (roomType === 'PRIVATE_SPACE') return <SendField roomId={roomId} />

  return <HallFooter roomId={roomId} roomType={roomType} />
})
